import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { addFulfillmentContextWorkflow } from './addFulfillmentContextWorkflow';
import { editFulfillmentContextWorkflow } from './editFulfillmentContext';

export const workflows: WorkflowOptions[] = [
  addFulfillmentContextWorkflow,
  editFulfillmentContextWorkflow,
  ...Object.values(generateAssetStatusWorkflow('fulfillmentContext')),
];

export default workflows;
